import { dispatch, RELEVANT_FILTER_WAS_CHANGED } from "./observer";

export const handler = (element) => {
  dispatch(RELEVANT_FILTER_WAS_CHANGED, element);
};
